import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { GrupoProdutoService } from '../services/grupo-produto.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import Swal from 'sweetalert2';
//GruposProdutoComponent
//PerfilUsuarioComponent
@Component({
	selector: 'app-perfil-usuario',
	templateUrl: './perfil-usuario.component.html',
	styleUrls: ['./perfil-usuario.component.css'],
	animations: [loadingFade, modal, alert]
})
export class PerfilUsuarioComponent implements OnInit {
	public loading = false;
	public gruposPerfil;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	constructor(private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {
		this.pegaPerfil();
	}

	pegaPerfil(){
		this.loading = true;
		this.perfilUsuarioSvc.getPerfil().then((data: any) => {
			this.gruposPerfil = data;
			this.count = this.gruposPerfil.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);scrollBy
			this.loading = false;
		});
	}


	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	
}
